const DEFAULT_STATE = {
    Person__c: [],
    Fund_Request__c: [],
    Application__c: [],
    Receipt__c: [],
    Account__c: [],
    timeFetched: null,
};

const fnList = {
    PERSON_DESCRIBE: (state, payload) => ({
        ...state,
        Person__c: payload,
    }),
    FR_DESCRIBE: (state, payload) => ({
        ...state,
        Fund_Request__c: payload,
    }),
    APPLICATION_DESCRIBE: (state, payload) => ({
        ...state,
        Application__c: payload,
    }),
    RECEIPT_DESCRIBE: (state, payload) => ({
        ...state,
        Receipt__c: payload,
    }),
    ACCOUNT_DESCRIBE: (state, payload) => ({
        ...state,
        Account__c: payload,
    }),
    DESCRIBE_OBJECT: (state, payload) => ({
        ...state,
        [payload.objectName]: payload.objectDescription,
        timeFetched: new Date().getTime(),
    }),
    LOGGED_OUT: () => DEFAULT_STATE,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const fn = fnList[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/reducers/objectInfoReducers.js
// module id = 1069
// module chunks = 0